import { ReactComponent as IconAdvisers } from "../../../assets/icons/departmentCards/Advisers.svg";
import { ReactComponent as IconAdvisersMap } from "../../../assets/icons/departmentCards/AdviserMap.svg";
import { ReactComponent as IconWebsiteEnquiries } from "../../../assets/icons/departmentCards/WebsiteEnquiries.svg";
import { ReactComponent as IconContactList } from "../../../assets/icons/departmentCards/TestContactList.svg";
import { ReactComponent as IconRecruitment } from "../../../assets/icons/departmentCards/RecruitmentApplications.svg";
import { ReactComponent as IconHighRiskCountries } from "../../../assets/icons/departmentCards/HighRiskCountries.svg";
import { ReactComponent as IconFinancialPromotions } from "../../../assets/icons/departmentCards/FinancialPromotions.svg";
import { ReactComponent as IconMembersHub } from "../../../assets/icons/departmentCards/MembersHub.svg";
import { ReactComponent as Icon1AIN } from "../../../assets/icons/departmentCards/1AIN.svg";
import { ReactComponent as IconProviderIndex } from "../../../assets/icons/departmentCards/ProviderIndex1.svg";
import { ReactComponent as IconSimplyBiz } from "../../../assets/icons/departmentCards/ConvertSimplyBizStatements.svg";
import { ReactComponent as IconCheck2Statements } from "../../../assets/icons/departmentCards/Check²Statements.svg";
import { ReactComponent as IconParaplanningCharges } from "../../../assets/icons/departmentCards/ParaplanningCharges.svg";
import { ReactComponent as IconParaplanningSalary } from "../../../assets/icons/departmentCards/ParaplanningSalaries.svg";
import { ReactComponent as IconProCeding } from "../../../assets/icons/departmentCards/ProCeding.svg";
import { ReactComponent as IconParaplanningDashboard } from "../../../assets/icons/departmentCards/ParaplanningDashboard.svg";
import { ReactComponent as IconMarketing } from "../../../assets/icons/departmentCards/Marketing.svg";
import { ReactComponent as IconAnnouncement } from "../../../assets/icons/departmentCards/Announcements.svg";
import { ReactComponent as IconSocialMediaContentManagement } from "../../../assets/icons/departmentCards/SocialMediaContentManagement.svg";
import { ReactComponent as IconStaffAccessOverview } from "../../../assets/icons/departmentCards/StaffAccessOverview.svg";
import { ReactComponent as IconHoliday } from "../../../assets/icons/departmentCards/StaffHolidays.svg";
import { ReactComponent as IconLicenceCertificate } from "../../../assets/icons/departmentCards/LicenceCertificates.svg";
import { ReactComponent as IconIFARates } from "../../../assets/icons/departmentCards/IFARates.svg";
import { ReactComponent as IconPlanTypeMapping } from "../../../assets/icons/departmentCards/IOPlanTypes.svg";
import { ReactComponent as IconCommissionSplitsIcon} from "../../../assets/icons/departmentCards/CommissionSplitEvents.svg";
import { ReactComponent as IconFCIStatements } from "../../../assets/icons/departmentCards/LiveFCIStatements.svg";
import { ReactComponent as IconMonthlyPayments } from "../../../assets/icons/departmentCards/MonthEndPayments.svg";
import { ReactComponent as IconBlogsAndNews } from "../../../assets/icons/departmentCards/newspaper.svg";
import { ReactComponent as IconProviderMatches } from "../../../assets/icons/departmentCards/ProviderMatches.svg";
import { ReactComponent as IconAdviserReports } from "../../../assets/icons/departmentCards/AdviserReports.svg";
import { ReactComponent as IconSecretSanta } from "../../../assets/icons/departmentCards/SecretSanta.svg";
import { ReactComponent as IconClientFeeAgreement } from "../../../assets/icons/departmentCards/ClientAgreementFeeStructures.svg";

import { APP_ROUTES } from "../../../constants/appRoutes";
import { FEATURE_FLAGS } from "../../../constants/featureFlags";

export const getDepartmentConfig = (permissions = []) => {
  const has = (p) => permissions.includes(p);
  const hasAny = (arr = []) => arr.some((p) => permissions.includes(p));

  const isHolidayOnlyUser =
    has("In House Advisers") || has("Holiday Only") || has("Staff Holidays");
  const canSeeCompliance = !isHolidayOnlyUser && hasAny([
    "Administrator", "Compliance", "Compliance Support", "Financial Promotions",
    "Financial Promotions Admin", "Finance Admin", "Adviser Support", "Marketing",
    "Recruitment", "Paraplanning", "Licence Certificates",
  ]);

  return {
    AllStaff: {
      title: "All Staff",
      show: true,
      cards: [
        {
          label: "Advisers",
          route: APP_ROUTES.ADVISERS,
          description: "View and manage advisers",
          icn: IconAdvisers,
          show: !isHolidayOnlyUser,
        },
        {
          label: "Adviser Map",
          route: APP_ROUTES.ADVISER_MAP,
          description: "Browse advisers by residential or business address",
          icn: IconAdvisersMap,
          show: !isHolidayOnlyUser,
        },
        {
          label: "Groups",
          route: APP_ROUTES.GROUP_DETAILS,
          description: "View Intelliflo group details from IO",
          icn: IconPlanTypeMapping,
          show: !isHolidayOnlyUser,
        },
        {
          label: "Holidays",
          route: APP_ROUTES.STAFF_HOLIDAY,
          description: "View and manage your holiday requests",
          icn: IconHoliday,
          show: true,
        },
        {
          label: "Contact List",
          route: APP_ROUTES.CONTACT_LIST,
          description: "Access adviser contact list",
          icn: IconContactList,
          show: !isHolidayOnlyUser,
        },
      ].filter((c) => c.show),
    },

    AdviserSupport: {
      title: "Adviser Support",
      show: !isHolidayOnlyUser && (has("Adviser Support") || has("Compliance")),
      cards: [
        {
          label: "Website Enquiries",
          route: APP_ROUTES.ENQUIRIES,
          description: "Manage enquiries",
          icn: IconWebsiteEnquiries,
          show: has("Enquiries"),
        },
      ].filter((c) => c.show),
    },

    Compliance: {
      title: "Compliance",
      show: canSeeCompliance,
      cards: [
        {
          label: "Recruitment Applications",
          route: APP_ROUTES.APPLICATIONS,
          description: "Review applications",
          icn: IconRecruitment,
          show: has("Recruitment") || has("Marketing") || has("Compliance"),
        },
        {
          label: "High Risk Countries",
          route: APP_ROUTES.HIGH_RISK_COUNTRIES,
          description: "Check restricted and high-risk countries",
          icn: IconHighRiskCountries,
          show: has("Check ² Admin") && has("Compliance"),
        },
        {
          label: "Financial Promotions",
          route: APP_ROUTES.FINANCIAL_PROMOTIONS,
          description: "Review and manage promotions",
          icn: IconFinancialPromotions,
          show: hasAny(["Financial Promotions", "Financial Promotions Admin"]),
        },
        {
          label: "Members Hub",
          route: APP_ROUTES.MEMBERS_HUB,
          description: "Open the members hub",
          icn: IconMembersHub,
          show: has("Compliance") || has("Marketing"),
        },
        {
          label: "1-AIN",
          route: APP_ROUTES.ONE_AIN,
          description: "Open the internal assistant",
          icn: Icon1AIN,
          show: has("Compliance") || has("Compliance Support"),
        },
        {
          label: "Provider Index",
          route: APP_ROUTES.PROVIDER_INDEX,
          description: "Manage provider network",
          icn: IconProviderIndex,
          show: has("Paraplanning"),
        },
        {
          label: "Licence/Certificates",
          route: APP_ROUTES.LICENCE_CERTIFICATES,
          description: "Manage licence and certificates",
          icn: IconLicenceCertificate,
          show:
            has("Administrator") ||
            has("Licence Certificates") ||
            has("Licence Certificates Admin") ||
            has("Compliance") ||
            has("Compliance Support") ||
            has("Adviser Support") ||
            has("Recruitment"),
        },
        {
          label: "IO Plan Type Mapping",
          route: APP_ROUTES.PLAN_TYPE_MAPPING,
          description: "Upload and maintain IO plan type categories",
          icn: IconPlanTypeMapping,
          show: (has("Compliance") && has("IO Admin")) || has("Administrator"),
        },
        {
          label: "Adviser Reports",
          route: APP_ROUTES.COMPLIANCE_REPORTS,
          description: "Export adviser details to Excel",
          icn: IconAdviserReports,
          show: canSeeCompliance,
        },
        {
          label: "Client Agreement Fee Structures",
          route: APP_ROUTES.CLIENT_AGREEMENT_FEE_STRUCTURES,
          description: "Manage adviser agreement fees and version history",
          icn: IconClientFeeAgreement,
          show: has("Compliance") || has("Compliance Support") || has("Administrator") || has("Adviser Support"),
        },
      ].filter((c) => c.show),
    },

    Intelliflo: {
      title: "Intelliflo",
      show:
        FEATURE_FLAGS.showIntellifloDepartment &&
        !isHolidayOnlyUser &&
        (has("Administrator") || has("IO Admin")),
      cards: [
        {
          label: "Adviser Gating",
          route: APP_ROUTES.INTELLIFLO_ADVISER_GATING,
          description: "Upload and populate adviser product gating permissions",
          icn: IconPlanTypeMapping,
          show: has("Administrator") || has("IO Admin"),
        },
        {
          label: "Intelliflo Identifier Upload",
          route: APP_ROUTES.INTELLIFLO_IO_ID_BULK_UPLOAD,
          description: "Map adviser emails and upload id, group.id and user.id",
          icn: IconPlanTypeMapping,
          show: has("Administrator") || has("IO Admin"),
        },
      ].filter((c) => c.show),
    },

    Finance: {
      title: "Finance",
      show:
        !isHolidayOnlyUser &&
        (has("Finance") ||
          has("Finance Admin") ||
          has("Administrator") ||
          has("Recruitment")),
      cards: [
        {
          label: "Installed IO Apps",
          route: APP_ROUTES.INSTALLED_IO_APPS,
          description: "View installed Intelliflo apps and associated users",
          icn: IconPlanTypeMapping,
          show: has("Administrator"),
        },
        {
          label: "Convert SimplyBiz Statements",
          route: APP_ROUTES.CONVERT_COMMISSION_STATEMENTS,
          description: "Convert SimplyBiz statements",
          icn: IconSimplyBiz,
          show: has("Finance"),
        },
        {
          label: "check² Statements",
          route: APP_ROUTES.CHECK2_STATEMENTS,
          description: "View check² statements",
          icn: IconCheck2Statements,
          show: has("Finance Admin") || has("Administrator"),
        },
        {
          label: "Paraplanning Charges",
          route: APP_ROUTES.PARAPLANNING_CHARGES,
          description: "View paraplanning charges",
          icn: IconParaplanningCharges,
          show: has("Finance Admin") || has("Administrator"),
        },
        {
          label: "Paraplanning Salaries",
          route: APP_ROUTES.PARAPLANNING_SALARIES,
          description: "View paraplanning salaries",
          icn: IconParaplanningSalary,
          show: has("Finance Admin") || has("Administrator"),
        },
        {
          label: "ProCeding Statements",
          route: APP_ROUTES.PRO_CEDING_STATEMENTS,
          description: "View ProCeding Statements",
          icn: IconProCeding,
          show: has("Finance Admin") || has("Administrator"),
        },
        {
          label: "IFA Rates",
          route: APP_ROUTES.IFA_RATES,
          description: "Review and manage adviser rates",
          icn: IconIFARates,
          show:
            has("Administrator") || has("Recruitment") || has("Finance Admin"),
        },
        {
          label: "Commission Split Events",
          route: APP_ROUTES.COMMISSION_SPLIT_EVENTS,
          description:
            "Monitor created, skipped and failed commission splits on IO",
          icn: IconCommissionSplitsIcon,
          show: has("Finance Admin") || has("Administrator") || has("Finance"),
        },
        // {
        //   label: "Fee Paid",
        //   route: APP_ROUTES.FEES_PAID,
        //   description: "View fee payments in IO and adviser payment values",
        //   icn: IconCommissionSplitsIcon,
        //   show: has("Finance Admin") || has("Administrator") || has("Finance"),
        // },
        {
          label: "FCI Reports",
          route: APP_ROUTES.FCI_REPORTS,
          description: "Get commission payments format from FCI reports",
          icn: IconFCIStatements,
          show:
            has("Finance Admin") ||
            has("Administrator") ||
            has("Finance Testing"),
        },
        {
          label: "Live FCI Statements",
          route: APP_ROUTES.LIVE_FCI_STATEMENTS,
          description: "View and export live FCI data from Snowflake",
          icn: IconFCIStatements,
          show:
            has("Finance Admin") ||
            has("Administrator") ||
            has("Finance") ||
            has("IO Support"),
        },
        {
          label: "Provider Matches",
          route: APP_ROUTES.PROVIDER_MATCHES,
          description:
            "Review IO payments against their provider statement sources",
          icn: IconProviderMatches,
          show:
            has("Finance Admin") ||
            has("Administrator") ||
            has("Finance") ||
            has("IO Support"),
        },
        {
          label: "Monthly Payments",
          route: APP_ROUTES.MONTHLY_PAYMENTS,
          description: "Monthly Commission Statements",
          icn: IconMonthlyPayments,
          show:
            has("Finance Admin") ||
            has("Administrator") ||
            has("Finance Testing") ||
            has("Tech"),
        },
      ].filter((c) => c.show),
    },

    Paraplanning: {
      title: "Paraplanning",
      show:
        !isHolidayOnlyUser &&
        (has("Administrator") ||
          has("Paraplanning") ||
          has("Finance") ||
          has("Paraplanning View Only")),
      cards: [
        {
          label: "Paraplanning Dashboard",
          route: APP_ROUTES.PARAPLANNING_DASHBOARD,
          description: "View paraplanning cases and performance",
          icn: IconParaplanningDashboard,
          show:
            has("Paraplanning") ||
            has("Finance") ||
            has("Paraplanning View Only"),
        },
        {
          label: "Paraplanning Charges",
          route: APP_ROUTES.PARAPLANNING_CHARGES_VIEW,
          description: "View paraplanning charges",
          icn: IconParaplanningCharges,
          show: has("Paraplanning") || has("Finance"),
        },
      ].filter((c) => c.show),
    },

    Marketing: {
      title: "Marketing",
      show:
        !isHolidayOnlyUser &&
        (has("Administrator") ||
          has("Marketing") ||
          has("Recruitment") ||
          has("Finance")),
      cards: [
        {
          label: "Blogs and Media",
          route: APP_ROUTES.MARKETING,
          description: "Update blogs and media",
          icn: IconBlogsAndNews,
          show: has("Marketing"),
        },
        {
          label: "Announcements",
          route: APP_ROUTES.MARKETING_ANNOUNCEMENTS,
          description:
            "Create and manage company updates seen on adviser portal",
          icn: IconAnnouncement,
          show: has("Administrator") || has("Marketing"),
        },
        {
          label: "design⁴",
          route: APP_ROUTES.MARKETING_WEBSITES,
          description: "Build and bill",
          icn: IconMarketing,
          show:
            has("Administrator") ||
            has("Marketing") ||
            has("Recruitment") ||
            has("Finance"),
        },
        {
          label: "Marketing Assistant",
          route: APP_ROUTES.SOCIAL_MEDIA_CONTENT_MANAGEMENT,
          description: "Create and manage Social Media Content",
          icn: IconSocialMediaContentManagement,
          show: has("Marketing"),
        },
      ].filter((c) => c.show),
    },

    Administrator: {
      title: "Administrator",
      show: !isHolidayOnlyUser && (has("Administrator") || has("Secret Santa")),
      cards: [
        {
          label: "Secret Santa",
          route: APP_ROUTES.SECRET_SANTA,
          description:
            "Organise the Christmas draw and send private match emails",
          icn: IconSecretSanta,
          show: has("Secret Santa"),
        },
        {
          label: "Staff Access Overview",
          route: APP_ROUTES.STAFF_ACCESS_OVERVIEW,
          description: "View staff access by permission and department",
          icn: IconStaffAccessOverview,
          show: has("Administrator"),
        },
        // {
        //   label: "Firestore Collection Copy",
        //   route: APP_ROUTES.FIRESTORE_COLLECTION_COPY,
        //   description: "Copy collections into the development database",
        //   icn: IconStaffAccessOverview,
        //   show: has("Prod"),
        // },
      ].filter((c) => c.show),
    },
    AdviserPortal: {
      title: "Adviser Portal",
      route: APP_ROUTES.ADVISER_PORTAL,
      // icn: IconAdviserPortal,
      show: !isHolidayOnlyUser,
    },
  };
};

export const getDepartmentCardByRoute = (permissions = [], route = "") =>
  Object.values(getDepartmentConfig(permissions))
    .flatMap((config) => config.cards || [])
    .find((card) => card.route === route);

export const canAccessDepartmentRoute = (permissions = [], route = "") =>
  Boolean(getDepartmentCardByRoute(permissions, route));

